import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { supportApi } from '../../services';
import { toast } from 'react-toastify';

const KnowledgeBase = () => {
    const [categories, setCategories] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        supportApi.getCategories()
            .then(res => setCategories(Array.isArray(res.data?.data) ? res.data.data : []))
            .catch(() => toast.error('Failed to load knowledge base'))
            .finally(() => setLoading(false));
    }, []);

    const filtered = (Array.isArray(categories) ? categories : []).filter(c =>
        !search || c.name?.toLowerCase().includes(search.toLowerCase()) || c.description?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div>
            <div className="search-wrap" style={{ marginBottom: 20, maxWidth: 500 }}>
                <i className="pi pi-search" />
                <InputText
                    placeholder="Search articles, FAQs, guides…"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    style={{ width: '100%' }}
                />
            </div>
            {loading && <div style={{ textAlign: 'center', padding: 20, color: 'var(--muted)' }}>Loading…</div>}
            <div className="grid-3">
                {filtered.map((cat, i) => (
                    <div className="kb-card" key={cat.id ?? i}>
                        <div className="kb-icon"><i className={`pi ${cat.icon ?? 'pi-file'}`} /></div>
                        <div className="kb-title">{cat.name}</div>
                        <div className="kb-desc">{cat.description}</div>
                        <div className="kb-count">{cat.articleCount ?? 0} articles →</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default KnowledgeBase;
